import angular from 'angular';

import modalCadastralReferenceComponent from './modalCadastralReference.component';

let modalCadastralReferenceModule = angular.module('modalCadastralReference', [
])

.component('modalCadastralReference', modalCadastralReferenceComponent)

.name;

export default modalCadastralReferenceModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalCadastralReference/modalCadastralReference.js